'use client';

import { useActiveBrand } from '@/_hooks/useActiveBrand';
import { IRedux } from '@/_store/types';
import { IShipper } from '@/_types';
import { Link } from '@/i18n/navigation';
import courierIcon from '@/shared/assets/svg/courier.svg';
import { Box, Flex, HStack, IconButton, Text } from '@chakra-ui/react';
import Image from 'next/image';
import { GoArrowLeft } from 'react-icons/go';
import { LuSearch } from 'react-icons/lu';
import { useSelector } from 'react-redux';
import BrandSelectMobile from './BrandSelectMobile';
import { useTranslations } from 'next-intl';

interface RestaurantHeaderProps {
  brand: IShipper | null;
}

export function HeaderStatic({ brand }: RestaurantHeaderProps) {
  const { branches } = useSelector((state: IRedux) => state.common);
  const shipperId = useActiveBrand()
  const branch = branches?.[shipperId]

  const t = useTranslations();

  return (
    <Box px={2} shadow='md' borderBottomRadius='xl' bg='white'>
      <HStack justify='space-between' py='2'>
        <Link href='/'>
          <IconButton aria-label='Back' variant='ghost' rounded='xl'>
            <GoArrowLeft strokeWidth='0.75' />
          </IconButton>
        </Link>

        <Link href={`/brand-search?restaurant=${brand?.id}`}>
          <IconButton aria-label='Search' variant='ghost' rounded='xl'>
            <LuSearch />
          </IconButton>
        </Link>
      </HStack>

      <Flex direction='column' p='4' pt='2' gap='4'>
        <BrandSelectMobile brandName={brand?.name || ''} />
        <HStack>
          <Image src={courierIcon} alt='' width={25} height={20} />
          <Box lineHeight={1.2} fontSize='xs'>
            <Text fontWeight={600}>
              {branch?.delivery_time || 0}-{(branch?.delivery_time || 0) + 10}{' '}
              {t('time')}
            </Text>
            <Text color='#A6A6A6'>{t('delivery')}</Text>
          </Box>
        </HStack>
      </Flex>
    </Box>
  );
}
